import type { AxiosError } from 'axios';
import type { ErrorResponse } from '@inmotion/models';

export default function getAxiosErrorCode(error: unknown): number | null {
  return (
    ((error as AxiosError)?.response?.data as ErrorResponse<number | undefined>)?.errorCode ?? null
  );
}
